import React from 'react';
import PropTypes from 'prop-types';

import DsLabel from '../label';
import Btn from './index';

const BtnEdit = ({
  label, className, onClick, children,
}, context) => {
  const getLabel = label || context.t('Edit');
  return (
    <Btn onClick={onClick} className={`${className || ''} flex justify-center items-center`}>
        <DsLabel icon="edit-circle" className="text-primary capitalize font-bold" iconClassName="text-xl">
          {children || getLabel}
        </DsLabel>
    </Btn>);
};

BtnEdit.propTypes = {
  label: PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.func.isRequired,
};

BtnEdit.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default BtnEdit;
